import { initBacklogService } from "../BacklogService";
import {
	type BacklogDIContainer,
	type BacklogDependenciesType,
	type Constructor,
	createContainer,
} from "./BacklogDIContainer";

const config: { container?: BacklogDIContainer } = {
	container: undefined,
};

function getContainerInstance(): BacklogDIContainer {
	if (!config.container) {
		config.container = createContainer();
		initBacklogService(config.container);
	}
	return config.container;
}

export function resolve<T>(className: string, dependencies?: unknown): T {
	return getContainerInstance().resolve(className, dependencies);
}

export function bind(
	className: string,
	classRef: Constructor<unknown>,
	dependencies?: BacklogDependenciesType,
): void {
	getContainerInstance().bind(className, classRef, dependencies);
}
